module.exports = ".libraries-card .card-header {\n    background-color: #0C9688;\n}\n\n.libraries-card {\n    background-color: #0C9B8E;\n}\n\n.libraries-card .row:nth-child(odd) {\n    background-color: #0C9688;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/select-library/select-library.modal.component.css
// module id = 912
// module chunks = 4